import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"

const Footer = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            author
          }
        }
      }
    `
  )
  const date = new Date()
  return (
    <footer className="bg-grayBg h-16 mt-1 flex flex-wrap px-8 items-center text-white text-sm justify-between font-header">
      <div>
        <Link to="/impressum">Impressum</Link>
      </div>
      <div>
        <Link to="#" className="pr-4">
          Wir
        </Link>
        <Link to="#" className="pr-4">
          Twitter
        </Link>
        <Link to="#" className="pr-4">
          YouTube
        </Link>
        <Link to="#">Instargram</Link>
      </div>
      <div>
        &copy; {site.siteMetadata.author} {date.getFullYear()}
      </div>
    </footer>
  )
}

export default Footer
